import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Dialog, Button, Group, useToast } from '@economic/taco';
import { refreshCurrentLegacyPage } from '@economic/react-app';
import internalApiClient from '../../../shared/util/api/internalApiClient';
import { Form } from '../../../shared/components/Form';

function CancelAdministratorDeregistrationPanel({ agreementNumber, hide }) {
    const toast = useToast();

    async function handleSubmit(values) {
        const activeToast = toast.loading('Loading');

        try {
            await internalApiClient.post(`system/administrator/${agreementNumber}/deregister/cancel`);

            activeToast.success('Deregistration of administrator has been cancelled');
            refreshCurrentLegacyPage('content');
            hide();
        } catch {
            activeToast.error('Error occured while cancelling administrator deregistration');
        }
    }

    return (
        <Form onSubmit={handleSubmit} skipNotifications>
            <Dialog.Title>Confirm</Dialog.Title>
            Cancel deregistration of administrator {agreementNumber}?
            <Dialog.Footer>
                <Group>
                    <Button appearance="default" onClick={hide}>
                        Cancel
                    </Button>
                    <Button appearance="primary" autoFocus type="submit">
                        Ok
                    </Button>
                </Group>
            </Dialog.Footer>
        </Form>
    );
}

export default function CancelAministratorDeregistrationDialog() {
    const navigate = useNavigate();
    const location = useLocation();
    let { agreementNumber } = location.state || ({} as any);

    function hide() {
        navigate(location.pathname);
    }

    return (
        <Dialog open={location.hash === '#cancel-administrator-deregistration'} size="xs" onClose={hide}>
            <Dialog.Content aria-label="">
                <CancelAdministratorDeregistrationPanel agreementNumber={agreementNumber} hide={hide} />
            </Dialog.Content>
        </Dialog>
    );
}
